module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/rc-progress/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 1547
// module chunks = 0